import { render, staticRenderFns } from "./AdminSlot.vue?vue&type=template&id=21e4ceb8"
import script from "./AdminSlot.vue?vue&type=script&lang=js"
export * from "./AdminSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports